import React, { useCallback, useEffect } from "react";
import Footer from "../footer";
import "./UserDashboard.css";
import { UseDashboardHook } from "./DashboardServices/useDashboardHook";
import { useState } from "react";
import Pagination, {
  bootstrap5PaginationPreset,
} from "react-responsive-pagination";
import useAuth from "../../Auth";

function UserDashboard() {
  const {
    referralLink,
    copyTextHandler,
    copied,
    challenges,
    Details,
    walletAddress,
    fetchProfileDetails,
  } = UseDashboardHook();
  const { Login, isAuthenticated } = useAuth();
  const [clicked, setClicked] = useState();
  const [Allclicked, setAllClicked] = useState();
  const [latestclicked, setlatestClicked] = useState(true);
  const [count, setCount] = useState(1);
  const [finalList, setFinalList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const id = localStorage.getItem("user_id");
  let winner = "Pending...";
  useEffect(() => {
    fetchProfileDetails(id, currentPage, 7);
  }, [currentPage]);
  useEffect(() => {
    if (!isAuthenticated) {
      Login();
    }
    return () => {
      setCount(1);
    };
  }, []);

  return (
    <>
      {/* <Header /> */}
      <main className="dashboard-main">
        <span className="main-line"></span>
        <section className="dash-sec1">
          <div className="container-1470">
            <div className="row dash-row1">
              <div className="col-lg-7 col-md-12 col-sm-12">
                <div className="row1-col1">
                  <div className="inner-col1 txt-col">
                    <h1>Hello</h1>
                    <h3 className="text-white">Wallet Address:</h3>
                    <span>
                      <span>{walletAddress}</span>
                      <img
                        className="copy-text"
                        src={require("./images/copy-img.png")}
                        alt="Copy"
                        onClick={() => copyTextHandler("wallet")}
                      />
                    </span>
                    <div className="total-game">
                      <p>Total Games Played</p>
                      <h1>{Details?.count?.total_challenges}</h1>
                    </div>
                  </div>
                  <div className="inner-col2 img-col">
                    <img
                      src={require("./images/dash-img1.png")}
                      alt="dash-img1"
                    />
                  </div>
                  <div className="dash-sec1 cards-row">
                    <div className="sec1-card card-col1">
                      <p>Total wins</p>
                      <h4>{Details?.count?.win_challenges}</h4>
                    </div>
                    <div className="sec1-card card-col2">
                      <p>Total Lose</p>
                      <h4>{Details?.count?.lose_challenges}</h4>
                    </div>
                    <div className="sec1-card card-col3">
                      <p>Total Amount Won</p>
                      <div className="card-total">
                        <h4>100,000</h4>
                        <img
                          src={require("./images/dash-matic.png")}
                          alt="matic"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-md-12 col-sm-12">
                <div className="row1-col2">
                  <h1>NFT Collection</h1>
                  <div className="col2-card-row">
                    <div className="card-col">
                      <img
                        src={require("./images/dash-col2-card.png")}
                        alt="NFT Collection"
                      />
                      <img
                        className="blurred-image-dash"
                        src={require("./images/dash-col2-card.png")}
                        alt="NFT Collection"
                      />
                    </div>
                    <div className="card-col">
                      <img
                        src={require("./images/dash-col2-card.png")}
                        alt="NFT Collection"
                      />
                      <img
                        className="blurred-image-dash"
                        src={require("./images/dash-col2-card.png")}
                        alt="NFT Collection"
                      />
                    </div>
                    <div className="card-col">
                      <img
                        src={require("./images/dash-col2-card.png")}
                        alt="NFT Collection"
                      />
                      <img
                        className="blurred-image-dash"
                        src={require("./images/dash-col2-card.png")}
                        alt="NFT Collection"
                      />
                    </div>
                    <div className="card-col">
                      <img
                        src={require("./images/dash-col2-card.png")}
                        alt="NFT Collection"
                      />
                      <img
                        className="blurred-image-dash"
                        src={require("./images/dash-col2-card.png")}
                        alt="NFT Collection"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="dash-sec2">
          <div className="container-1470">
            <div className="row dash-row2">
              <div className="col-lg-7 col-md-12 col-sm-12">
                <div className="sec2-col1-row-main">
                  <div className="sec2-col1-row1">
                    <h3>referral</h3>
                    <div className="address-row">
                      <p>
                        {referralLink?.slice(0, 60) + "..." ||
                          "https://gamingarcade.io"}
                      </p>
                      <img
                        className="copy-text"
                        src={require("./images/copy-img.png")}
                        alt="copy"
                        onClick={() => copyTextHandler("referlink")}
                      />
                      <img
                        src={require("./images/share-img.png")}
                        alt="share"
                      />
                    </div>
                    <div className="copied-row">
                      <br />
                      {/* {copied ? (
                          <p className="text-warning">Copied to clipboard!</p>
                        ) : (
                          ""
                        )} */}
                    </div>
                  </div>
                  <div className="sec2-col1-buton">
                    <p>Total Refferals</p>
                    <h1>{Details?.count?.referUsers}</h1>
                  </div>
                  <div className="sec2-col1-cards">
                    <div className="sec2-card card-1">
                      <p>Lvl 1</p>
                      <h2>20K</h2>
                      <span>see List</span>
                    </div>
                    <div className="sec2-card card-2">
                      <p>Lvl 2</p>
                      <h2>20K</h2>
                      <span>see List</span>
                    </div>
                    <div className="sec2-card card-3">
                      <p>Lvl 3</p>
                      <h2>20K</h2>
                      <span>see List</span>
                    </div>
                    <div className="sec2-card card-4">
                      <p>Lvl 4</p>
                      <h2>20K</h2>
                      <span>see List</span>
                    </div>
                    <div className="sec2-card card-5">
                      <p>Lvl 5</p>
                      <h2>20K</h2>
                      <span>see List</span>
                    </div>
                  </div>
                  <p className="sec2-last-icon">
                    How referral Works{" "}
                    <img
                      src={require("./images/exp-icon.png")}
                      alt="explanation"
                    />
                  </p>
                </div>
              </div>
              <div className="col-lg-5 col-md-12 col-sm-12">
                <div className="row h-100">
                  <div className="col mr-2 dash-sec2-col ml-0">
                    <h3>
                      Total Earnings{" "}
                      <img
                        src={require("./images/exp-icon.png")}
                        alt="explanation"
                      />
                    </h3>
                    <div className="sec2-card-col3">
                      <h1>10,000</h1>
                      <img
                        src={require("./images/dash-matic.png")}
                        alt="matic"
                      />
                    </div>
                  </div>
                  <div className="col ml-2 dash-sec2-col">
                    <h3>
                      Total Withdrawl{" "}
                      <img
                        src={require("./images/exp-icon.png")}
                        alt="explanation"
                      />
                    </h3>
                    <div className="sec2-card-col3">
                      <h1>10</h1>
                      <img
                        src={require("./images/dash-matic.png")}
                        alt="matic"
                      />
                      <p>Withdrawls</p>
                    </div>
                  </div>
                  <div className="col-12 sec2-col3">
                    <h2>Withdraw</h2>
                    <div className="sec2-table-cols sec2-table-col3-1">
                      <p>
                        Earnings available To Withdraw{" "}
                        <span>(via Refferals)</span>{" "}
                        <img
                          src={require("./images/exp-icon.png")}
                          alt="explanation"
                        />
                      </p>
                      <div className="table-num">
                        <p>67.5 + 7.5</p>
                        <img
                          src={require("./images/dash-matic.png")}
                          alt="matic"
                        />
                      </div>
                    </div>
                    <div className="sec2-table-cols sec2-table-col3-2">
                      <p>
                        Comission + transection Fee{" "}
                        <img
                          src={require("./images/exp-icon.png")}
                          alt="explanation"
                        />
                      </p>
                      <div className="table-num">
                        <p>1 + 2</p>
                        <img
                          src={require("./images/dash-matic.png")}
                          alt="matic"
                        />
                      </div>
                    </div>
                    <div className="sec2-table-cols sec2-table-col3-3">
                      <p>
                        Total Withdraw{" "}
                        <img
                          src={require("./images/exp-icon.png")}
                          alt="explanation"
                        />
                      </p>
                      <div className="table-num">
                        <p>74</p>
                        <img
                          src={require("./images/dash-matic.png")}
                          alt="matic"
                        />
                      </div>
                    </div>
                    <div className="sec2-foter">
                      <p>Minimum withdrawl amount is 1,000 matic</p>
                      <button type="button">Withdraw</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="dash-sec3">
          <div className="container-1470">
            <div className="row">
              <div className="col-md-12 col-12">
                <div className="sec3-head-1">
                  <h1>referral Amount</h1>
                </div>
                <div className="sec3-table-row">
                  <table className="table table-borderless align-middle">
                    <thead>
                      <tr>
                        <th>no.</th>
                        <th>Date & Time</th>
                        <th>referral Level</th>
                        <th>Referral Address</th>
                        <th>
                          Amount{" "}
                          <img
                            src={require("./images/exp-icon.png")}
                            alt="explanation"
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>10</td>
                        <td>25 JUly 2022 | 10:00am GMT</td>
                        <td>Lvl 4</td>
                        <td>
                          5KZz2zLvY8ZcMnT86RHygNHkCRAU7dQU2GiFjJhoNbEg15a9sGp{" "}
                          <img
                            src={require("./images/share-img2.png")}
                            alt="share"
                          />
                        </td>
                        <td>
                          1.0005{" "}
                          <img
                            src={require("./images/dash-matic.png")}
                            alt="matic"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>09</td>
                        <td>25 JUly 2022 | 10:00am GMT</td>
                        <td>Lvl 4</td>
                        <td>
                          5KZz2zLvY8ZcMnT86RHygNHkCRAU7dQU2GiFjJhoNbEg15a9sGp{" "}
                          <img
                            src={require("./images/share-img2.png")}
                            alt="share"
                          />
                        </td>
                        <td>
                          1.0005{" "}
                          <img
                            src={require("./images/dash-matic.png")}
                            alt="matic"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>08</td>
                        <td>25 JUly 2022 | 10:00am GMT</td>
                        <td>Lvl 4</td>
                        <td>
                          5KZz2zLvY8ZcMnT86RHygNHkCRAU7dQU2GiFjJhoNbEg15a9sGp{" "}
                          <img
                            src={require("./images/share-img2.png")}
                            alt="share"
                          />
                        </td>
                        <td>
                          1.0005{" "}
                          <img
                            src={require("./images/dash-matic.png")}
                            alt="matic"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>07</td>
                        <td>25 JUly 2022 | 10:00am GMT</td>
                        <td>Lvl 4</td>
                        <td>
                          5KZz2zLvY8ZcMnT86RHygNHkCRAU7dQU2GiFjJhoNbEg15a9sGp{" "}
                          <img
                            src={require("./images/share-img2.png")}
                            alt="share"
                          />
                        </td>
                        <td>
                          1.0005{" "}
                          <img
                            src={require("./images/dash-matic.png")}
                            alt="matic"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>06</td>
                        <td>25 JUly 2022 | 10:00am GMT</td>
                        <td>Lvl 4</td>
                        <td>
                          5KZz2zLvY8ZcMnT86RHygNHkCRAU7dQU2GiFjJhoNbEg15a9sGp{" "}
                          <img
                            src={require("./images/share-img2.png")}
                            alt="share"
                          />
                        </td>
                        <td>
                          1.0005{" "}
                          <img
                            src={require("./images/dash-matic.png")}
                            alt="matic"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <button type="button">Load More</button>
              </div>
            </div>
          </div>
        </section>
        <section className="dash-sec4">
          <div className="container-1470">
            <div className="row">
              <div className="col-md-12 col-12">
                <div className="sec4-head-row1">
                  <div className="sec4-head-1">
                    <h1>Game History</h1>
                  </div>
                  <div className="sec4-head-2">
                    <h4>Sort By:</h4>
                    <p
                      style={{ cursor: "pointer" }}
                      className={latestclicked ? "sort-active" : ""}
                      onClick={() => setlatestClicked(!latestclicked)}
                    >
                      latest
                    </p>
                    <p
                      style={{ cursor: "pointer" }}
                      className={clicked ? "sort-active" : ""}
                      onClick={() => setClicked(!clicked)}
                    >
                      this week
                    </p>
                    <p
                      style={{ cursor: "pointer" }}
                      className={Allclicked ? "sort-active" : ""}
                      onClick={() => setAllClicked(!Allclicked)}
                    >
                      All
                    </p>
                  </div>
                </div>
                <div className="sec4-table-row">
                  <table className="table table-responsive table-borderless align-middle">
                    <thead>
                      <tr>
                        <th>Game id</th>
                        <th>Game</th>
                        <th>Bet Amount</th>
                        <th>Score (you / opp)</th>
                        <th>opponent address</th>
                        <th>
                          Result{" "}
                          <img
                            src={require("./images/exp-icon.png")}
                            alt="explanation"
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {Details?.total_challenges?.map((item, index) => {
                        if (
                          item?.winner?.address &&
                          item?.winner?.address === id
                        ) {
                          winner = "Player 1";
                        } else if (
                          item?.winner?.address &&
                          item?.winner?.address !== id
                        ) {
                          winner = "Player 2";
                        } else {
                          winner = "Pending...";
                        }
                        return (
                          <tr key={index}>
                            <td>{item?.gameId}</td>
                            <td>{item?.gameName}</td>
                            <td>{item?.betAmount}</td>
                            <td>{`${
                              item?.player1?.player_id === id
                                ? item?.player1?.score
                                : item?.player2?.score || 0
                            }/${
                              (item?.player2?.player_id !== id
                                ? item?.player2?.score
                                : item?.player1?.score) || 0
                            }`}</td>
                            <td>
                              {(item?.player2?.player_id !== id
                                ? item?.player2?.player_id
                                : item?.player1?.player_id) || "None"}
                              {/* <img
                                src={require("./images/share-img2.png")}
                                alt="share"
                              /> */}
                            </td>
                            <td>
                              {winner}
                              <img
                                src={require("./images/share-img2.png")}
                                alt="share"
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <Pagination
                  {...bootstrap5PaginationPreset}
                  current={currentPage}
                  total={Details?.pagination?.pages}
                  onPageChange={setCurrentPage}
                />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default React.memo(UserDashboard);
